module.exports = __webpack_public_path__ + "media/courses/curricula/images/level-lock-5c074de400707b1c102abca7c85bc7ff.svg";